<template>
	<v-form v-model="valid" ref="form">

		<v-tabs-items v-model="tab">
			
			<!-- dotações anular -->
			<v-tab-item value="tabDotacoesAnular">
				<v-decreto-dotacao-list v-model="dotacoesDecretoAnular" :read-only="readOnly" :dotEmenda="true" :dotAnular="true"/>
		
				<v-divider></v-divider>
				
				<v-row>
					<v-col md="3" offset-md="3">
					</v-col>
				</v-row>
			</v-tab-item>

			<!-- dotações a suplementar -->
			<v-tab-item value="tabDotacoesSuplementar">
				<v-form ref="formDotacao" @keyup.native.enter="incluirDotacao">
					<v-row>

						<v-col md="6">
							<v-btn primary @click="exibirPesqDotacaoSuplementar" :disabled="readOnly">
								<v-icon color="primary">mdi-plus</v-icon> Pesquisar Dotação a Suplementar
							</v-btn>
						</v-col>

						<v-col class="pt-0 pb-0" cols="12" md="2">
							<v-text-field
								v-model="anoOrcamento"
								label="Ano Orçamento"
								type="number"
								:disabled="true"
							/>
						</v-col>

						<v-col class="pt-0 pb-0" cols="12" md="1">
							<v-text-field
								v-model="numeroDotacao"
								label="Nr. Despesa"
								type="number"
								autofocus
								:disabled="readOnly"
							/>
						</v-col>

						<!-- <v-col class="text-right">
							<v-btn primary @click="incluirDotacao" :disabled="readOnly">
								<v-icon color="primary">mdi-plus</v-icon> Incluir Dotação
							</v-btn>
						</v-col> -->
					
					</v-row>
				</v-form>
				
				<v-decreto-dotacao-list v-model="dotacoesDecretoSuplementar" :read-only="readOnly" :dotEmenda="true" :dotSup="true"/>
			</v-tab-item>

		</v-tabs-items>

		<!-- tela de pesquisa de dotação a suplementar -->
		<v-bottom-sheet persistent width="70%" v-model="solicitarDotacaoSup">
			<v-sheet class="text-center">

				<v-col md="12">
					<v-form v-model="dotacaoValida" ref="formPesqDotacaoSup">

						<v-dotacao-list v-model="dotacoesSecretaria" :read-only="readOnly" @clicar="enviarDotacaoSup"/>

						<v-row>
							<v-col md="12">
								<v-btn
									class="mr-5"
									outlined
									v-shortkey.once="['esc']"
									@shortkey="cancelarDotacaoSup"
									@click="cancelarDotacaoSup"
								>
									Cancelar
								</v-btn>
							</v-col>
						</v-row>

					</v-form>
				</v-col>
			</v-sheet>
		</v-bottom-sheet>

		<v-bottom-sheet persistent width="70%" v-model="solicitarDotacaoAnular">
			<v-sheet class="text-center">

				<v-col md="12">
					<v-form v-model="dotacaoValida" ref="formPesqDotacaoSup">

						<v-dotacao-list v-model="dotacoesEmenda" :read-only="readOnly" @clicar="enviarDotacaoAnular"/>

						<v-row>
							<v-col md="12">
								<v-btn
									class="mr-5"
									outlined
									v-shortkey.once="['esc']"
									@shortkey="cancelarDotacaoAnular"
									@click="cancelarDotacaoAnular"
								>
									Cancelar
								</v-btn>
							</v-col>
						</v-row>

					</v-form>
				</v-col>
			</v-sheet>
		</v-bottom-sheet>

	</v-form>
</template>

<script>
import VDotacaoList from '@/components/DotacaoList.vue';
import VDecretoDotacaoList from '@/components/DecretoDotacaoList.vue';

export default {
	props: ['value', 'tab', 'readOnly', 'diferenca'],
	data() {
		return {
			//número da emenda, situação da emenda, secretaria, número da dotação, justificativa da emenda, instituição de destino, paamentar, e observações
			id: null,
			numeroDecreto: null,
			//idEmendaAnulada: null,
			valor: 0,
			anoExercicio: null,
			dataDecreto: null,
			dotacoesDecreto: [],

			dotacoesDecretoAnular: [],
			dotacoesDecretoSuplementar: [],
			dotacoesSecretaria: [],
			dotacoesEmenda: [],

			solicitarDotacaoSup: false,
			solicitarDotacaoAnular: false,

			valid: null,
			dotacaoValida: null,

			numeroDotacao: null,
			anoOrcamento: null

		};
	},
	components: { VDotacaoList, VDecretoDotacaoList },
	
	watch: {
		value(decreto) {

			this.id = decreto.id;
			this.numeroDecreto = decreto.numeroDecreto;
			this.dataDecreto = decreto.dataDecreto;
			this.anoExercicio = decreto.anoExercicio;

			if ((decreto) && (decreto.dotacoesDecreto)) {
				this.dotacoesDecreto = decreto.dotacoesDecreto;
				this.dotacoesDecretoAnular = decreto.dotacoesDecretoAnular;
				this.dotacoesDecretoSuplementar = decreto.dotacoesDecretoSuplementar;
			}

		},

		$data: {
			handler() {
				this.atualizarValue();
			},
			deep: true
		},

		anoExercicio(value) {
			if (value) {
				this.anoOrcamento = value;
			}
		}

	},

	async mounted() {
		if (this.$route.params.id == 'novo') {
			await this.pesquisarDotacoesProjetoLei();
		}
	},

	methods: {

		async salvar() {
			try {

				this.$emit('salvando', true);
				await this.$refs.form.validate();

				let decretoSalvo;
				let decretosSalvar = [];
				let vlTotalAnulado = 0;

				if (this.valid) {

					let temValor0Anulado = false;
					let temValor0Sup = false;

					for (let index = 0; index < this.dotacoesDecretoAnular.length; index++) {
						vlTotalAnulado = vlTotalAnulado + parseFloat(this.dotacoesDecretoAnular[index].valorAnulado);
						if (this.dotacoesDecretoAnular[index].valorAnulado == 0) {
							temValor0Anulado = true;
						}			
					}

					for (let index = 0; index < this.dotacoesDecretoSuplementar.length; index++) {
						if (this.dotacoesDecretoSuplementar[index].valorSuplementado == 0) {
							temValor0Sup = true;
						}			
					}
					
					if ((!temValor0Anulado) && (!temValor0Sup)) {

						if (this.diferenca == 0) {

							if (this.dotacoesDecretoAnular) {
								for (let index = 0; index < this.dotacoesDecretoAnular.length; index++) {
									decretosSalvar.push({idDotacao:this.dotacoesDecretoAnular[index].dotacao.id,valorAnulado:this.dotacoesDecretoAnular[index].valorAnulado,valorSuplementado:0});							
								}
							} 
							
							if (this.dotacoesDecretoSuplementar) {
								for (let index = 0; index < this.dotacoesDecretoSuplementar.length; index++) {
									decretosSalvar.push({idDotacao:this.dotacoesDecretoSuplementar[index].dotacao.id,valorAnulado:0,valorSuplementado:this.dotacoesDecretoSuplementar[index].valorSuplementado});							
								}
							} 
										
							this.value.dotacoesDecreto = decretosSalvar;
							
							if (this.id) {
								decretoSalvo = await this.$fetch.put(
									`decretos/${this.id}`,
									this.value
								);
								this.$emit('updated', decretoSalvo);
							} else {
								decretoSalvo = await this.$fetch.post(`decretos`, this.value);
								this.$emit('saved', decretoSalvo);
							}
						}
						else {
							this.$root.dialog = { title: 'Decreto não salvo', msg: 'Valor suplementado total deve ser igual ao valor anulado total.' };
						}
					} 
					else {
						this.$root.dialog = { title: 'Decreto não salvo', msg: 'Informe valores a anular/suplementar em todas as dotações.' };
					}

				}
				
				return decretoSalvo;
			
			} catch (err) {
				this.$root.dialog = { title: 'Decreto não salvo', msg: err.msg };
			} finally {
				this.$emit('salvando', false);
			}
		},

		async remover() {
			try {
				this.$emit('removendo', true);
				let decretoRemovido = await this.$fetch.delete(`decretos/${this.id}`);
				this.$emit('deleted', decretoRemovido);
				this.$emit('removendo', false);
				return decretoRemovido;
			} catch (err) {
				this.$root.dialog = { title: 'Decreto não Removido', msg: err.msg };
			}
		},

		async obterDecreto(id) {
			return this.$fetch.get(`decretos/${id}`);
		},
		limparCampos() {
			this.$refs.form.reset();
		},

		atualizarValue() {
			this.$emit('input', {
				id: this.id,
				numeroDecreto: this.numeroDecreto,
				dataDecreto: this.dataDecreto,
				valor: this.valor,
				anoExercicio: this.anoExercicio
			});
		},

		setMascara(v) {
			return v.toLocaleString('pt-BR', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				style: 'currency',
				currency: 'BRL'
			});
		},

		async enviarDotacaoSup(dotacoesSelecionadas) {

			if (dotacoesSelecionadas.anoOrcamento == this.anoExercicio) {

				if (this.dotacoesDecretoSuplementar.filter(d => (d.dotacao.id == dotacoesSelecionadas.id)).length == 0
					&& this.dotacoesDecretoAnular.filter(d => (d.dotacao.id == dotacoesSelecionadas.id)).length == 0) 
				{
					this.dotacoesDecretoSuplementar.push({valorSuplementado:0,valorAnulado:0,dotacao:dotacoesSelecionadas});	
				}
			}
			else {
				this.$root.dialog = { title: 'Dotação não incluída', msg:'Dotação deve pertencer ao mesmo ano do decreto' };
			}

			this.solicitarDotacaoSup = false;
		},

		async enviarDotacaoAnular(dotacoesSelecionadas) {

			if (this.dotacoesDecretoSuplementar.filter(d => (d.dotacao.id == dotacoesSelecionadas.id)).length == 0
				&& this.dotacoesDecretoAnular.filter(d => (d.dotacao.id == dotacoesSelecionadas.id)).length == 0) 
			{
				this.dotacoesDecretoAnular.push({valorSuplementado:0,valorAnulado:0,dotacao:dotacoesSelecionadas});	
			}

			this.solicitarDotacaoAnular = false;
		},

		async exibirPesqDotacaoSuplementar() {

			try {
				//let anoDecreto = this.dataDecreto.substr(6,4);

				//if (anoDecreto.length == 4) {
					await this.pesquisarDotacoesSecretarias();
					this.solicitarDotacaoSup = true;
				//} else {
				//	throw "Informe corretamente o ano do decreto";
				//}
			} catch {
				this.$root.dialog = { title: 'Pesquisa de Dotação', msg:'Erro pesquisando dotação' };
			}

		},

		cancelarDotacaoSup() {
			this.solicitarDotacaoSup = false;
		},

		async exibirPesqDotacaoAnular() {
			this.solicitarDotacaoAnular = true;
		},

		cancelarDotacaoAnular() {
			this.solicitarDotacaoAnular = false;
		},

		async pesquisarDotacoesSecretarias() {
			// pesquisar as dotações da secretaria
			try {
				this.dotacoesSecretaria = await this.$fetch.get('emendas/dotacoesSuplementar');
				this.dotacoesSecretaria = this.dotacoesSecretaria.filter(d => d.anoOrcamento == this.anoExercicio);
			} catch {
				this.dotacoesSecretaria = [];
			}
		},

		async pesquisarDotacoesProjetoLei() {
			
			let anoExercicio = this.anoExercicio = this.$root.anoSelecionado;

			// pesquisar as dotações pertencentes à emenda com situação "elaboração de projeto de lei"
			try {
				this.dotacoesSecretaria = await this.$fetch.get('emendas/dotacoesAnular', {anoExercicio: anoExercicio});

				for (let index = 0; index < this.dotacoesSecretaria.length; index++) {
					this.dotacoesDecretoAnular.push({valorSuplementado:0,valorAnulado:this.dotacoesSecretaria[index].valorFixadoFinal,dotacao:this.dotacoesSecretaria[index]});	
				}

			} catch {
				this.dotacoesSecretaria = [];
			}
		},

		pesquisarDotacoesEmenda(decreto) {
			// trazer as dotações da emenda do decreto para poder selecionar para anular
			try {
				if ((decreto) && (decreto.emenda) && (decreto.emenda.dotacoes)) {
					this.dotacoesEmenda = decreto.emenda.dotacoes;
				}
			} catch {
				this.dotacoesEmenda = [];
			}
		},

		async incluirDotacao() {
			if ((this.anoOrcamento) && (this.numeroDotacao))
			{
				try {
					let dotacao = await this.$fetch.get('decretos/dotacao/', {
						anoOrcamento: this.anoOrcamento,
						numeroDotacao: this.numeroDotacao
					});
					this.dotacoesDecretoSuplementar.push({valorSuplementado:0,valorAnulado:0,dotacao:dotacao});	

					this.anoOrcamento = null;
					this.numeroDotacao = null;

				} catch (err) {
					this.$root.dialog = { title: 'Dotação não incluída', msg: err.msg };
				}
			}
			else {
				this.$root.dialog = { title: 'Dotação não incluída', msg: 'Informe Nr. e Ano do Orçamento' };
			}

		}
		
	}
};
</script>

<style scoped>
.centered-input >>> input {
	text-align: center;
}
.centered-input >>> label {
	right: -50% !important;
	text-align: center !important;
}
.vermelho >>> .v-input__slot {
	background-color: #ff9595 !important;
}
.verde >>> .v-input__slot {
	background-color: #95ff9d !important;
}
.situacao {
	font-weight: bold;
	color: orangered;
}
.info-despacho {
	text-align: center;
	font-size: 80%;
}
form >>> *  {
	color: rgba(0, 0, 0, 0.87) !important;
}
</style>
